import { render } from "./EducationComponent.vue?vue&type=template&id=4e217255&scoped=true"
import script from "./EducationComponent.vue?vue&type=script&lang=js"
export * from "./EducationComponent.vue?vue&type=script&lang=js"

import "./EducationComponent.vue?vue&type=style&index=0&id=4e217255&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e217255"]])

export default __exports__